import axios from "axios";

// https://medium.com/canariasjs/vue-api-calls-in-a-smart-way-8d521812c322

const vueAppApi = process.env.VUE_APP_API;

const baseDomain = vueAppApi || "https://customercareapidev.fgt.llc";
const version = "v1";
const baseURL = `${baseDomain}/api/${version}`;

const instance = axios.create({
  baseURL,
});

instance.interceptors.request.use(function (request) {
  var token = null;
  var userName = null;
  let idToken = null;
  for (const [key, value] of Object.entries(localStorage)) {
    if (key.match(/(^CognitoIdentityServiceProvider).*(\.accessToken)+/)) {
      token = value;
    }
    if (key.match(/(^CognitoIdentityServiceProvider).*(\.idToken)+/)) {
      idToken = value;
    }
    if (key.match(/(user_info)/)) {
      var arr = JSON.parse(value).email.split("@");
      userName = arr[0].toLowerCase();

      if (userName.includes(".")) {
        var firstLast = userName.split(".");
        userName = firstLast[0][0] + firstLast[1];
      }
    }
  }
  if (idToken.length) {
    request.headers["Authorization"] = "Bearer " + idToken;
  } else if (token.length) {
    request.headers["Authorization"] = "Bearer " + userName;
  }

  return request;
});

export default instance;
